import { createMuiTheme } from '@material-ui/core/styles';

// Create a theme instance.
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#FBD10F',
    },
    secondary: {
      main: '#0A0A0A',
    },
    error: {
      main: '#323232',
    },
    background: {
      default: '#FFF',
    },
  },
  typography: {
    fontFamily: [
      'Poppins',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    caption: {
      color: '#888',
      fontSize: 11,
    }
  },
  overrides: {
    // fix safari margin bug
    MuiGrid: {
      'spacing-xs-1': {
        margin: 0
      },
    },
  },
});

export default theme;